// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { isSameDay as fn } from "../isSameDay.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const isSameDay = convertToFP(fn, 2);

// Fallback for modularized imports:
export default isSameDay;
